import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SessionStorageService } from 'src/app/services/session-storage.service';
import { LoggingMessageService } from 'src/app/services/logging-message.service';
import { environment } from 'src/environments/environment';
import { UserNavigationService } from 'src/app/services/user-navigation.service';
import { AuthService } from 'src/app/services/auth.service';
import { DomSanitizer } from '@angular/platform-browser';
import { WindowEventsService } from 'src/app/services/window-events.service';
import { IframeService } from 'src/app/services/iframe.service';
import { BaseWebsiteComponent } from '../base-website/base-website.component';
import { PendoService } from 'src/app/services/pendo.service';
import { pairwise, startWith } from 'rxjs/operators';
import { SubscriptionChangeService } from 'src/app/services/subscription-change.service';

@Component({
    standalone: true,
    selector: 'app-indicator',
    templateUrl: './indicator.component.html'
})

export class IndicatorComponent
    extends BaseWebsiteComponent
    implements OnInit, OnDestroy {
    public showPrBackButton = false;
    private pressureInjuries: string;
    private restraints: string;
    private pressureInjuriesAndRestraints: string;
    private pressureInjuries2: string;
    private restraints2: string;
    private pressureInjuriesAndRestraints2: string;

    constructor(
        public router: Router,
        public route: ActivatedRoute,
        public logger: LoggingMessageService,
        public navigationService: UserNavigationService,
        public sessionService: SessionStorageService,
        public authService: AuthService,
        public windowEvents: WindowEventsService,
        public pendoService: PendoService,
        public iframeService: IframeService,
        public sanitizer: DomSanitizer,
        public subscriptionService: SubscriptionChangeService) {
        super(router, route, logger, sessionService, navigationService, authService, windowEvents, iframeService, pendoService, sanitizer, subscriptionService);
    }

    ngOnInit() {
        this.reqestSizeFromIFrame();
        super.ngOnInit();

        this.pressureInjuries = `indicator/${environment.PressureInjuriesIndicatorId}`;
        this.restraints = `indicator/${environment.RestraintsIndicatorId}`;
        this.pressureInjuriesAndRestraints = `indicator/${environment.PressureInjuriesAndRestrainstsIndicatorId}`;

        this.pressureInjuries2 = `indicator/${environment.PressureInjuriesIndicatorId2}`;
        this.restraints2 = `indicator/${environment.RestraintsIndicatorId2}`;
        this.pressureInjuriesAndRestraints2 = `indicator/${environment.PressureInjuriesAndRestrainstsIndicatorId2}`;

        this.selectedSubscriptionID = this.subscriptionService.SelectedSubscription;
        this.availableSubscriptions = this.subscriptionService.AvailableSubscriptionsString;
    }

    subscribeToChildSiteEvents() {
        this.subscribeIndicatorResizingEvents();
        this.subscribeIndicatorBuildEvents();
        this.subscribeIndicatorRerouteEvents();
        this.subscribeIndicatorLogout();
        this.subscribeSubDomainActionEvents();

        const addSubscription = this.iframeService.indicatorFrameLoaded$
            .subscribe(v => this.reqestSizeFromIFrame());
        this.$subscriptions.add(addSubscription);

        const prSubscription = this.iframeService.ndnqiPublicReportsFrameLoaded$.subscribe(v => {
            const prIframe = this.visibleIframe = document.getElementById('appNdnqiPublicReportsIFrame') as HTMLIFrameElement;
            if (prIframe) {
                prIframe.contentWindow.postMessage('sizing?', '*');
            }
        });
        this.$subscriptions.add(prSubscription);

        const prvSubscription = this.iframeService.ndnqiPublicReportsVisibility$.subscribe(val => {
           this.showPrBackButton = val;
        });
        this.$subscriptions.add(prvSubscription);

        this.subscribeToPreviousValue();
    }

    getIframeReferences() {
        if (!this.visibleIframe) {
            this.visibleIframe = document.getElementById('appIndicatorIframe') as HTMLIFrameElement;
        }
    }

    // showIFClient() {
    //     this.iframeService.setNdnqiPublicReportsFrameVisibility(false);
    // }

    private subscribeIndicatorResizingEvents() {
        const indicatorSubscription = this.windowEvents.indicatorResizing$
            .subscribe(size => {
                this.updateIframeHeight(size);
            });
        this.$subscriptions.add(indicatorSubscription);
    }

    private subscribeIndicatorBuildEvents() {
        const indicatorRebuiltSubscription = this.windowEvents.indicatorRebuilt$
            .subscribe(indicatorid => {
                this.checkAccessToken();
            });
        this.$subscriptions.add(indicatorRebuiltSubscription);
    }

    private subscribeIndicatorRerouteEvents() {
        const indicatorSubscription = this.windowEvents.indicatorReroute$
            .subscribe(link => {
                this.loadIframe(link);
            });
        this.$subscriptions.add(indicatorSubscription);
    }

    private subscribeIndicatorLogout() {
        const indicatorSubscription = this.windowEvents.indicatorLogout$
            .subscribe(logout => {
                this.logger.debug('indicator.component.ts', 'subscribeIndicatorLogout', this.subscriptionService.SelectedSubscription, this.subscriptionService.AvailableSubscriptionsString, 'Indicator Logout message received', '');
                this.authService.publishLoginStatusUpdate(false);
            });
        this.$subscriptions.add(indicatorSubscription);
    }

    private subscribeToPreviousValue() {
        const pvSubscription = this.iframeService.indicatorSource$.pipe(
            startWith(this.currentUrl),
            pairwise())
            .subscribe(([previousValue, currentValue]) => {
                this.previousUrl = previousValue;
            });
        this.$subscriptions.add(pvSubscription);
    }

    loadIframe(path: string) {
        const isLoggedIn = this.authService.isUserLoggedIn();
        if (isLoggedIn === true) {
            const displayedMenu = this.navigationService.DisplayedNavigationMenu;
            if (displayedMenu && displayedMenu.Items && displayedMenu.Items.length > 0) {
                this.updatePendo();
                this.setSessionVariables(path);
                this.setIframeSource(path);
                this.iframeService.setIndicatorFrameVisibility(true);
                this.iframeService.setLinkId('');
            } else {
                this.router.navigated = false;
            }
        }
    }

    reloadHiddenIframe() {
        const w: any = window;
        this.pendoService.updatePendo(w);
    }

    setIframeSource(path: string) {
        const iframe = document.getElementById('appIndicatorIframe') as HTMLIFrameElement;
        if (iframe) {
            path = path.replace('/if', '');
            path = path.replace('/indicatorfactory/', '');
            if (path.startsWith('/')) {
                path = path.substring(1, path.length - 1);
            }
            const user = this.authService.getUser();
            this.logger.debug('indicator', 'setIframeSource', this.selectedSubscriptionID, this.availableSubscriptions,`Src: ${path}`, '');
            this.currentUrl = path;
            const isTutorial = ((this.currentUrl) && (this.currentUrl.includes('tutorials/ModuleHomePage.aspx')));
            const isPressureInjuriesAndRestraints = ((this.currentUrl) && (this.currentUrl.includes(this.pressureInjuriesAndRestraints)));
            const isPressureInjuries = ((this.currentUrl) && (this.currentUrl.includes(this.pressureInjuries)));
            const isRestraints = ((this.currentUrl) && (this.currentUrl.includes(this.restraints)));
            const isPressureInjuriesAndRestraints2 = ((this.currentUrl) && (this.currentUrl.includes(this.pressureInjuriesAndRestraints2)));
            const isPressureInjuries2 = ((this.currentUrl) && (this.currentUrl.includes(this.pressureInjuries2)));
            const isRestraints2 = ((this.currentUrl) && (this.currentUrl.includes(this.restraints2)));

            const showBack = isTutorial ||
                             isPressureInjuries || isRestraints || isPressureInjuriesAndRestraints ||
                             isPressureInjuries2 || isRestraints2 || isPressureInjuriesAndRestraints2;
            this.showBackButton = showBack;

            this.iframeService.setIndicatorFrameSource(path);
            this.navigationService.emitNavigationComplete(this.linkid);
        }
    }

    updateIframeHeight(data: any) {
        const iframe = this.visibleIframe;
        if (iframe) {
            const height = parseFloat(data);
            if (height > 1000) {
                iframe.style.height = (height + 100) + 'px';
                const user = this.authService.getUser();
                this.logger.debug('indicator', 'updateIframeHeight',  this.selectedSubscriptionID, this.availableSubscriptions, `Setting IFrame height to ${data}`, '');
            } else {
                iframe.style.height = '1000px'; // Minimum height is set as 1000px
            }
        }
    }

    goBack() {
        const url = this.previousUrl;
        if (url) {
            this.loadIframe(url.replace(environment.WebServer, ''));
        }
    }

    ngOnDestroy(): void {
        this.visibleIframe = null;
        this.iframeService.setIndicatorFrameVisibility(false);

        super.ngOnDestroy();
    }
}
